import React from 'react';
import { HbrOption, HbrSelect } from '@harbor/elements-react-standalone';
import {
  FiscalPeriodRow,
  resolveTimeRange,
  TIME_PERIOD_OPTIONS,
  TimePeriodId,
} from '../../support/fiscalTimePeriods';
import { formatPeriodRange } from '../../support/attainmentLeader';
import { asSingleValue } from '../../support/utils';

interface Props {
  periodId: TimePeriodId;
  onChange: (id: TimePeriodId) => void;
  periods: FiscalPeriodRow[];
  /** The fiscal calendar is still loading. */
  loading?: boolean;
  /** Why the page fell back to All time, if it did. */
  notice?: string | null;
}

/** Current Fiscal Month / Quarter / Year / All — scopes a Leader tab's time-bound data (Salesforce, Campaigns). */
export default function TimePeriodSelect({ periodId, onChange, periods, loading, notice }: Props) {
  const today = new Date();
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-end gap-3 flex-wrap">
        <div className="min-w-[320px]">
          <div className="hbr-css__text-primary-xs-semibold mb-1">Time Period (Cisco fiscal calendar)</div>
          <HbrSelect value={periodId} onHbr-change={(e) => onChange(asSingleValue(e.target.value) as TimePeriodId)}>
            {TIME_PERIOD_OPTIONS.map((o) => {
              const range = resolveTimeRange(o.id, today, periods);
              const unavailable = o.periodType != null && !loading && !range;
              return (
                <HbrOption key={o.id} value={o.id} disabled={unavailable}>
                  {range ? `${o.label} (${formatPeriodRange(range)})` : o.label}
                </HbrOption>
              );
            })}
          </HbrSelect>
        </div>
      </div>
      {notice ? <div style={{ fontSize: '0.8125rem', color: '#b45309' }}>{notice}</div> : null}
    </div>
  );
}
